(function () {
  var page = document.querySelector('[data-event-page]');
  if (!page) return;

  var configEl = document.querySelector('[data-event-config]');
  var config = configEl ? JSON.parse(configEl.textContent) : {};
  var unitPrice = parseFloat(page.getAttribute('data-unit-price')) || 0;
  var capacity = parseInt(page.getAttribute('data-capacity'), 10) || 10;

  /* Le reveal au scroll est géré globalement par guticafe-reveal.js (chargé dans
     theme.liquid sur toutes les pages) — pas besoin de le dupliquer ici. */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(name, detail) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, detail || {}));
  }
  track('lat_view', { chapter: config.chapter });

  var introObserved = false;
  var introEl = document.getElementById('intrigue');
  if (introEl && 'IntersectionObserver' in window) {
    var introObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !introObserved) {
          introObserved = true;
          track('lat_experience_scroll', {});
          introObserver.disconnect();
        }
      });
    }, { threshold: 0.3 });
    introObserver.observe(introEl);
  }

  function formatMoney(amount) {
    return amount.toFixed(2).replace('.', ',') + ' $ CAD';
  }

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function sessionIsoRange(label) {
    if (!config.dateISO || !label) return null;
    var m = label.match(/(\d{1,2})\s*h\s*(\d{2})?/i);
    if (!m) return null;
    var startMinutes = parseInt(m[1], 10) * 60 + (m[2] ? parseInt(m[2], 10) : 0);
    var endMinutes = startMinutes + (config.duration || 65);
    var start = config.dateISO + 'T' + pad2(Math.floor(startMinutes / 60)) + ':' + pad2(startMinutes % 60) + ':00-04:00';
    var end = config.dateISO + 'T' + pad2(Math.floor(endMinutes / 60)) + ':' + pad2(endMinutes % 60) + ':00-04:00';
    return { start: start, end: end };
  }

  var sessionButtons = document.querySelectorAll('[data-session-btn]');
  var guestsBlock = document.querySelector('[data-guests-block]');
  var attendeesBlock = document.querySelector('[data-attendees-block]');
  var attendeesFields = document.querySelector('[data-attendees-fields]');
  var recapBlock = document.querySelector('[data-recap-block]');
  var qtyValueEl = document.querySelector('[data-qty-value]');
  var qtyMinusBtn = document.querySelector('[data-qty-minus]');
  var qtyPlusBtn = document.querySelector('[data-qty-plus]');
  var subtotalInlineEl = document.querySelector('[data-subtotal-inline]');
  var exclusiveNoteEl = document.querySelector('[data-exclusive-note]');
  var recapSessionEl = document.querySelector('[data-recap-session]');
  var recapCountEl = document.querySelector('[data-recap-count]');
  var recapSubtotalEl = document.querySelector('[data-recap-subtotal]');
  var recapTotalEl = document.querySelector('[data-recap-total]');
  var recapHeadingEl = document.querySelector('[data-recap-heading]');
  var confirmBtn = document.querySelector('[data-confirm-btn]');
  var errorEl = document.querySelector('[data-error-msg]');

  var state = { variantId: null, label: null, maxAvailable: 0, qty: 1, attendeeValues: [] };

  sessionButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      sessionButtons.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      state.variantId = btn.getAttribute('data-variant-id');
      state.label = btn.getAttribute('data-label');
      state.maxAvailable = Math.min(capacity, parseInt(btn.getAttribute('data-available'), 10) || 0);
      state.qty = 1;
      track('lat_session_selected', { session: state.label });

      guestsBlock.hidden = false;
      updateQtyUI();
      renderAttendeeFields();
      updateRecap();
      guestsBlock.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    });
  });

  function updateQtyUI() {
    qtyValueEl.textContent = state.qty;
    qtyMinusBtn.disabled = state.qty <= 1;
    qtyPlusBtn.disabled = state.qty >= state.maxAvailable;
    var subtotal = unitPrice * state.qty;
    subtotalInlineEl.textContent = formatMoney(subtotal);
    exclusiveNoteEl.hidden = !(state.maxAvailable === capacity && state.qty === capacity);
  }

  qtyMinusBtn.addEventListener('click', function () {
    if (state.qty > 1) {
      state.qty -= 1;
      updateQtyUI();
      renderAttendeeFields();
      updateRecap();
    }
  });
  qtyPlusBtn.addEventListener('click', function () {
    if (state.qty < state.maxAvailable) {
      state.qty += 1;
      track('lat_guest_count_selected', { count: state.qty });
      updateQtyUI();
      renderAttendeeFields();
      updateRecap();
    }
  });

  function renderAttendeeFields() {
    attendeesBlock.hidden = false;
    var frag = document.createDocumentFragment();
    for (var i = 0; i < state.qty; i++) {
      var existing = state.attendeeValues[i] || { first: '', last: '' };
      var label = document.createElement('div');
      label.className = 'event-attendee-label';
      label.textContent = i === 0 ? 'Votre nom' : 'Invité ' + (i + 1);
      frag.appendChild(label);

      var row = document.createElement('div');
      row.className = 'event-attendee-row';

      var first = document.createElement('input');
      first.type = 'text';
      first.placeholder = 'Prénom';
      first.required = true;
      first.value = existing.first;
      first.setAttribute('data-attendee-first', i);

      var last = document.createElement('input');
      last.type = 'text';
      last.placeholder = 'Nom';
      last.required = true;
      last.value = existing.last;
      last.setAttribute('data-attendee-last', i);

      row.appendChild(first);
      row.appendChild(last);
      frag.appendChild(row);
    }
    attendeesFields.innerHTML = '';
    attendeesFields.appendChild(frag);

    attendeesFields.querySelectorAll('input').forEach(function (input) {
      input.addEventListener('input', function () {
        var idx = parseInt(input.getAttribute('data-attendee-first') !== null ? input.getAttribute('data-attendee-first') : input.getAttribute('data-attendee-last'), 10);
        state.attendeeValues[idx] = state.attendeeValues[idx] || { first: '', last: '' };
        if (input.hasAttribute('data-attendee-first')) state.attendeeValues[idx].first = input.value;
        else state.attendeeValues[idx].last = input.value;
        updateRecap();
      });
    });

    recapBlock.hidden = false;
  }

  function updateRecap() {
    var subtotal = unitPrice * state.qty;
    recapSessionEl.textContent = state.label || '—';
    recapCountEl.textContent = state.qty;
    recapSubtotalEl.textContent = formatMoney(subtotal);
    recapTotalEl.textContent = formatMoney(subtotal) + ' (avant taxes)';
    if (recapHeadingEl) {
      var buyerFirst = ((state.attendeeValues[0] && state.attendeeValues[0].first) || '').trim();
      recapHeadingEl.textContent = buyerFirst ? 'La réservation de ' + buyerFirst : 'Votre réservation';
    }
  }

  confirmBtn.addEventListener('click', function () {
    errorEl.hidden = true;
    if (!state.variantId) {
      errorEl.textContent = 'Veuillez choisir une séance.';
      errorEl.hidden = false;
      return;
    }
    for (var i = 0; i < state.qty; i++) {
      var check = state.attendeeValues[i] || { first: '', last: '' };
      if (!check.first.trim() || !check.last.trim()) {
        errorEl.textContent = 'Veuillez indiquer le prénom et le nom de chaque participant — requis pour valider les entrées le jour de l\'événement.';
        errorEl.hidden = false;
        attendeesBlock.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        return;
      }
    }
    var properties = { 'Séance': state.label, 'Chapitre': config.chapter };
    for (var i = 0; i < state.qty; i++) {
      var v = state.attendeeValues[i] || { first: '', last: '' };
      var full = (v.first + ' ' + v.last).trim();
      properties[i === 0 ? 'Votre nom' : ('Invité ' + (i + 1))] = full;
    }
    var isoRange = sessionIsoRange(state.label);
    if (isoRange) {
      properties['_event_start_iso'] = isoRange.start;
      properties['_event_end_iso'] = isoRange.end;
      properties['_event_venue'] = config.venue || '';
      properties['_event_address'] = config.address || '';
      properties['_event_title'] = config.chapter || '';
    }

    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Un instant…';
    track('lat_checkout_started', { session: state.label, count: state.qty });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: state.variantId, quantity: state.qty, properties: properties }] })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.data && result.data.description ? result.data.description : 'Cette séance vient de se remplir. Veuillez choisir une autre heure.');
        }
        track('lat_purchase_completed', { session: state.label, count: state.qty });
        window.location.href = config.checkoutUrl || '/checkout';
      })
      .catch(function (err) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'Confirmer et payer';
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      });
  });
})();
